export const authState = state => state.ui.auth;